import { styled } from "styled-components";

export const HeaderWriteStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #383838;
  color: #fff;
  border-radius: 30px;
  cursor: pointer;
  font-size: 12px;
  margin-right: 24px;
  width: 45px;
  height: 45px;
`;
